import React, { useState } from 'react';
import BEM from 'common/bem';

const classes = BEM.with('ClinicalWorkflows');

type InsightsView = 'my-liveboards' | 'nurse-call' | 'consults';

const INSIGHTS_VIEWS: { id: InsightsView; label: string }[] = [
  { id: 'my-liveboards', label: 'My Liveboards' },
  { id: 'nurse-call', label: 'Nurse Call' },
  { id: 'consults', label: 'Consults' },
];

export default function InsightsTab() {
  const [activeInsightsView, setActiveInsightsView] = useState<InsightsView>('my-liveboards');

  return (
    <div className={classes('insights-split')} data-test-id="clinical-workflows-insights-content">
      <div className={classes('insights-nav')}>
        {INSIGHTS_VIEWS.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            className={classes('insights-nav-item', { selected: activeInsightsView === id })}
            onClick={() => setActiveInsightsView(id)}
            data-test-id={`clinical-workflows-insights-${id}`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className={classes('insights-content')}>
        <div className={classes('insights-placeholder')}>
          <div className={classes('insights-placeholder-icon')}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path d="M3 3v18h18" />
              <path d="m19 9-5 5-4-4-3 3" />
            </svg>
          </div>
          <h3 className={classes('insights-placeholder-title')}>Coming Soon</h3>
          <p className={classes('insights-placeholder-text')}>
            {INSIGHTS_VIEWS.find((v) => v.id === activeInsightsView)?.label} insights will be
            available here.
          </p>
        </div>
      </div>
    </div>
  );
}
